import styled from "@emotion/styled/macro";

const Header = styled.header`
  background: ${({ theme }) => theme.colors.cultered};
  background-image: url("${(props) => props.src}");
  background-repeat: no-repeat;
  background-size: 100% ${(props) => (props.padding ? props.padding : "250px")};
  padding-top: ${(props) => (props.padding ? props.padding : "250px")};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background-image: none;
    margin-bottom: 0;
    padding-top: 0;
    display: flex;
    box-shadow: 0px -7px 32px 0px ${({ theme }) => theme.colors.mint} inset;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 250px;
  }
`;
const TextContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 4em 4em 4em 14%;
    width: 50%;
  }
  padding: 2em;
  line-height: 1.5em;
`;
const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.75em;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    word-wrap: break-word;
    line-height: 1em;
  }
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
`;
const HeaderImg = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    background-image: url("${(props) => props.src}");
    background-repeat: no-repeat;
    background-size: cover;
    width: 50%;
    padding-top: 18em;
  }
`;
const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.5em;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1.5em;
  line-height: 1em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;
const Subsubtitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 1em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
  white-space: pre-line;
`;
const PageHeader = ({ text, title, imgMobile, background, subtitle, subsubtitle, padding }) => {
  return (
    <Header src={imgMobile} padding={padding}>
      <TextContainer>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {subsubtitle && <Subsubtitle>{subsubtitle}</Subsubtitle>}
        <Text>{text}</Text>
      </TextContainer>
      <HeaderImg src={background} />
    </Header>
  );
};

export default PageHeader;
